// extracted by mini-css-extract-plugin
export default {"mainHeader":"Header_mainHeader__0cqDq","logo":"Header_logo__UsziS","logoImg":"Header_logoImg__49vq6","logoColor":"Header_logoColor__0zt7x","mobileMenu":"Header_mobileMenu__bIYn6"};